import { ComponentPropsWithoutRef } from 'react';
import { DropdownMenu } from 'radix-ui';

export type MenuRadioGroupProps = ComponentPropsWithoutRef<
  typeof DropdownMenu.RadioGroup
>;

export function MenuRadioGroup(props: MenuRadioGroupProps) {
  return <DropdownMenu.RadioGroup {...props} />;
}
